"use client";
import React from "react";
import { motion } from "framer-motion";
import Image from "next/image";
import { ArrowRight, Search } from "lucide-react";

export default function Hero() {
  return (
    <section
      className="relative w-full overflow-hidden"
      style={{
        backgroundColor: "#ffffff",
        backgroundImage: `
    radial-gradient(
      60% 80% at 50% -10%,
      rgba(127, 161, 255, 0.2) 0%,
      rgba(127, 161, 255, 0) 60%
    ),
    repeating-linear-gradient(
      to right,
      rgba(102, 102, 102, 0.13) 0 1px,
      transparent 1px 76px
    ),
    repeating-linear-gradient(
      to bottom,
      rgba(102, 102, 102, 0.13) 0 1px,
      transparent 1px 76px
    )
  `,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center -10px, 0 -10px, 0 -1px",
      }}
    >
      <div className="relative px-6 md:px-[40px] xl:px-20 pt-12 lg:pt-20 pb-16 lg:pb-24">
        <div className="pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[1] w-[1500px] mt-[50px] h-[900px] bg-white rounded-full blur-[107.63px]" />
        <div className="relative z-20 grid grid-cols-1 items-center gap-12 lg:grid-cols-2 lg:gap-10">
          {/* left — copy */}
          <div className="flex flex-col items-center text-center lg:items-start lg:text-left">
            {/* badge */}
            <div className="mb-8 flex items-center gap-2 rounded-full border border-[#1414141A]/10 bg-white py-1.5 pl-1.5 pr-3">
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11Z"
                  fill="#10B981"
                />
                <path
                  d="M16 11H14L12.5 15.5L9.5 6.5L8 11H6"
                  stroke="white"
                  strokeWidth="0.5"
                />
              </svg>

              <span className="text-[12px] font-medium text-[#292929]">
                SEO Content Platform
              </span>
            </div>

            <h1 className="w-full max-w-[400px] xl:max-w-[480px] 2xl:max-w-[500px] 3xl:max-w-[600px] xl:leading-[1.1] leading-[1.2] solution-heading ">
              Content that ranks and reads well.
            </h1>

            <p className="mt-6 w-full max-w-[500px] body-secondary-text">
              Generate SEO-ready blog posts, article outlines, and optimised
              copy with natural keyword density built to boost organic traffic
              without stuffing.
            </p>

            {/* CTAs */}
            <div className="mt-10 flex flex-col items-center gap-3 sm:flex-row">
              <a
                href="https://app.imagive.ai?redirect=/users/white-chat-board"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary gap-1 group inline-flex items-center justify-center"
              >
                Generate google copy now{" "}
                <ArrowRight
                  size={16}
                  className="group-hover:translate-x-1 duration-300 transition-all  "
                />
              </a>
              <a
                href="https://cal.com/imagive.ai/30min"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-secondary w-full sm:w-auto inline-flex items-center justify-center"
              >
                No Credit Card Required
              </a>
            </div>
          </div>

          {/* right — SEO editor mockup */}
          <div className="relative h-[420px] w-full sm:h-[480px] lg:h-[560px]">
            <Image
              src="/assets/platforms/seo/seoEditor.svg"
              alt="Imagive SEO editor with live Google search preview, heading outline, and keyword tags"
              fill
              sizes="(max-width: 1024px) 100vw, 50vw"
              className="object-contain object-center lg:object-right"
              priority
            />
          </div>
        </div>
      </div>
    </section>
  );
}
